var _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscoverCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 15,
    viewBox: "0 0 84 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9865 0.505615C40.085 0.505615 36.9194 3.55352 36.9194 7.31513C36.9194 11.3146 39.9475 14.3041 43.9865 14.3041C47.9248 14.3041 51.0343 11.2749 51.0343 7.39371C51.0343 3.53547 47.9456 0.505615 43.9865 0.505615Z",
    fill: "url(#paint0_linear_1439_8501)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1439_8501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9865 0.505615C40.085 0.505615 36.9194 3.55352 36.9194 7.31513C36.9194 11.3146 39.9475 14.3041 43.9865 14.3041C47.9248 14.3041 51.0343 11.2749 51.0343 7.39371C51.0343 3.53547 47.9456 0.505615 43.9865 0.505615Z",
    fill: "#FF5F00"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86657 0.753687H0.0673828V14.0051H3.84672C5.85198 14.0051 7.30216 13.53 8.57436 12.4761C10.0838 11.2243 10.9788 9.33663 10.9788 7.38571C10.9788 3.47346 8.05621 0.753687 3.86657 0.753687ZM6.88796 10.7063C6.07112 11.4432 5.01936 11.7618 3.34793 11.7618H2.65359V2.9976H3.34793C5.01936 2.9976 6.03077 3.29597 6.88796 4.07003C7.78192 4.86491 8.31504 6.09578 8.31504 7.36684C8.31504 8.64067 7.78192 9.91449 6.88796 10.7063ZM12.172 14.0051H14.7541V0.753687H12.1723V14.0051H12.172ZM21.0754 5.83679C19.5236 5.26186 19.0669 4.88264 19.0669 4.16991C19.0669 3.33469 19.88 2.6994 20.9946 2.6994C21.7694 2.6994 22.4052 3.01713 23.0828 3.76987L24.4323 2.00425C23.3195 1.02862 21.9886 0.532598 20.5366 0.532598C18.1943 0.532598 16.4046 2.1627 16.4046 4.32642C16.4046 6.15598 17.2385 7.08898 19.6635 7.96552C20.6773 8.32132 21.1927 8.55867 21.4517 8.72087C21.9682 9.05877 22.2277 9.53397 22.2277 10.0899C22.2277 11.1646 21.3725 11.9581 20.2184 11.9581C18.9862 11.9581 17.9938 11.3429 17.3974 10.1906L15.7302 11.8018C16.9201 13.5479 18.3511 14.3254 20.3202 14.3254C23.0026 14.3254 24.8891 12.5347 24.8891 9.97225C24.8891 7.86563 24.0171 6.91116 21.0754 5.83679ZM25.7035 7.38588C25.7035 11.2846 28.7646 14.3041 32.6999 14.3041C33.8125 14.3041 34.7662 14.0841 35.9398 13.5298V10.4881C34.9051 11.5225 33.9908 11.9386 32.8179 11.9386C30.2156 11.9386 28.3663 10.0505 28.3663 7.36684C28.3663 4.82472 30.2733 2.81751 32.6999 2.81751C33.93 2.81751 34.8654 3.25432 35.9398 4.30738V1.26598C34.8072 0.691704 33.8718 0.454834 32.759 0.454834C28.8436 0.454834 25.7035 3.53528 25.7035 7.38588ZM56.8824 9.65501L53.3452 0.753687H50.5232L56.1489 14.3436H57.5387L63.2625 0.753524H60.4615L56.8824 9.65501ZM64.4375 14.0052H71.769V11.7618H67.0203V8.18255H71.5872V5.93879H67.0203V2.99744H71.769V0.753849H64.4374V14.0052H64.4375ZM82.0001 4.66448C82.0001 2.18206 80.2935 0.753687 77.311 0.753687H73.4754V14.0051H76.0612V8.67922H76.3996L79.9746 14.0051H83.1542L78.9785 8.42332C80.9288 8.02442 82.0001 6.69251 82.0001 4.66448ZM76.8133 6.85292H76.0612V2.83752H76.8547C78.4677 2.83752 79.3416 3.51511 79.3416 4.80471C79.3416 6.13499 78.4677 6.85292 76.8133 6.85292Z",
    fill: "#0B1015"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1439_8501",
    x: 36.9194,
    y: 0.505615,
    width: 17.1147,
    height: 16.7986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1439_8501"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1439_8501",
    x1: 310.946,
    y1: 125.561,
    x2: 1264.68,
    y2: 1132.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69E35"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverCard);
export default __webpack_public_path__ + "static/media/discoverCard.1474d0f7b714be314c4456130ac8fd5c.svg";
export { ForwardRef as ReactComponent };